<template>
  <div>
    <el-dialog :visible.sync="show" width="30%" title="修改密码" @close="cancel">
      <el-form ref="passwordModal" :model="form" :rules="formRule" label-width="100px">
          <el-form-item label="旧密码：" prop="old_password">
            <el-input v-model="form.old_password" style="width:240px;" placeholder="请填写原始密码" autocomplete="new-password" type="password" />
          </el-form-item>
          <el-form-item label="新密码：" :error="errorMsg" prop="new_password">
            <el-input v-model="form.new_password" @on-blur="handleBlur" style="width:240px;" placeholder="请填写新密码" autocomplete="new-password" type="password" />
          </el-form-item>
          <el-form-item label="确认密码：" :error="errorMsg" prop="again_password">
            <el-input v-model="form.again_password" @on-blur="handleBlur" style="width:240px;" placeholder="请填写新密码" autocomplete="new-password" type="password" />
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button size="medium" type="text" @click="cancel">取消</el-button>
          <el-button size="medium" type="primary" :loading="loading" @click="onSubmit">保存</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// import { resetCurrentUserPassword } from '@/service/user'
  export default {
    data() {
      return {
        loading: false,
        show: false,
        form: {
          old_password: '',
          new_password: '',
          again_password: '',
        },
        errorMsg: '',
        formRule: {
          old_password: [
            {required: true, message: "请填写原始密码", trigger: "change" },
            { type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' }
          ],
          new_password: [
            {required: true, message: "请填写原始密码", trigger: "change" },
            { type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' }
          ],
          again_password: [
            {required: true, message: "请填写原始密码", trigger: "change" },
            { type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      open() {
        this.show = true
      },
      cancel() {
        this.show = false
        this.$refs.passwordModal.resetFields()
      },
      handleBlur() {
        if (this.form.again_password == this.form.new_password) {
          this.errorMsg = ''
        }
      },
      onSubmit() {
        this.$refs.passwordModal.validate(async (valid) => {
          if (valid) {
            let data = Object.assign({}, this.form)
            if (data.again_password != data.new_password) {
              this.errorMsg = '两次输入的新密码不一致'
              return
            } else {
              this.errorMsg = ''
            }
            this.loading = true
            // let res = await resetCurrentUserPassword(data)
            // this.loading = false
            // if (res.code === 0) {
            //   this.$message.success('修改成功！')
            //   this.cancel()
            // }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>